import PropTypes from 'prop-types'
import React, { Suspense } from 'react'

import { CHILDREN } from 'constants/props'
import { en as genericsMessages } from 'translation/components/Generics'
import ErrorBoundary from 'generics/ErrorBoundary'

const isDevelopment = process.env.NODE_ENV !== 'production'
const defaultChunkLoadError = genericsMessages.chunkLoadError

const SuspenseWithErrorBoundary = ({
  children,
  chunkLoadError = defaultChunkLoadError,
  className,
  errorBoundaryClassName,
  fallback,
  ...suspenseProps
}) => (
  <ErrorBoundary
    className={errorBoundaryClassName || className}
    DEVELOPMENT={isDevelopment}
    errorMessage={chunkLoadError.message}
    errorTitle={chunkLoadError.title}
    reloadLabel={chunkLoadError.reload}
    showReloadOnChunkError
  >
    <Suspense fallback={fallback} {...suspenseProps}>
      {children}
    </Suspense>
  </ErrorBoundary>
)

SuspenseWithErrorBoundary.propTypes = {
  children: CHILDREN,
  chunkLoadError: PropTypes.shape({
    message: PropTypes.string,
    reload: PropTypes.string,
    title: PropTypes.string,
  }),
  className: PropTypes.string,
  errorBoundaryClassName: PropTypes.string,
  fallback: PropTypes.node,
}

SuspenseWithErrorBoundary.defaultProps = {
  children: null,
  chunkLoadError: defaultChunkLoadError,
  className: null,
  errorBoundaryClassName: null,
  fallback: null,
}

export { SuspenseWithErrorBoundary }
export default SuspenseWithErrorBoundary
